$(document).ready(function(){

  if ($("#homepage").length){


  }

});



// WEBPACK FOOTER //
// ./resources/assets/js/public/home.js